(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('.section-header');
      this.headerIsAlwaysSticky = true;
      this.addEventListener('preventHeaderReveal', () => {});
    }
    reveal() {
      if (this.header) this.header.classList.remove('shopify-section-header-hidden');
    }
    closeMenuDisclosure() {
      this.querySelectorAll('header-menu').forEach((menu) => menu.close());
    }
    closeSearchModal() {
      const search = this.querySelector('details-modal');
      if (search) search.close(false);
    }
  }
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
